export enum DocumentTypes {
  COMPANY = 'Company Documents',
  FACILITY = 'Facility Photos',
  CERTIFICATE = 'Licenses & Certificates',
  PRODUCT = 'Product Information',
}
